import gql from 'graphql-tag';

const GET_SHEETS_LIST = gql`
  query getSheetsList($subject: ID!, $curriculum: [String]) {
    sheets(subject: $subject, curriculum: $curriculum)
  }
`;

export default GET_SHEETS_LIST;
